export const patents = {
  published: [
    {
      id: 'us-patent-1',
      title: 'Process for the preparation of bimetallic core/shell nanoparticles and their catalytic applications',
      patentNumber: 'US 11,305,344 B2',
      inventors: ['C P Vinod', 'Vysakh Alengattil Bharathan'],
      year: '2022',
      status: 'Granted',
      type: 'US Patent',
      link: 'https://patents.google.com/patent/US11305344B2/'
    }
  ],
  provisional: [
    {
      id: 'in-patent-1',
      title: 'A PROCESS FOR THE SYNTHESIS OF METAL CATALYSTS',
      applicationNumber: '201811017972',
      inventors: ['Vinod Chathakudath Prabhakaran', 'Yogita Soni'],
      filingDate: '2018',
      status: 'Pending',
      type: 'Indian Patent Application'
    },
    {
      id: 'in-patent-2',
      title: 'SUPPORTED MULTIMETALLIC CATALYST FOR TUNING AND ENHANCING SELECTIVITY IN CO2 HYDROGENATION AND PROCESS OF PREPARATION THEREOF',
      applicationNumber: '202211060659',
      inventors: ['Vinod Chathakudath Prabhakaran', 'Jyotsna Paliwal'],
      filingDate: '2022',
      status: 'Pending',
      type: 'Indian Patent Application'
    },
    {
      id: 'in-patent-3',
      title: 'Fe-CRYSTALLINE SILICA BASED MATERIALS FOR CATALYTIC REACTIONS AND ITS PREPARATION THEREOF',
      applicationNumber: '202211062721',
      inventors: ['Vinod Chathakudath Prabhakaran', 'Anuradha Vijay Jagtap'],
      filingDate: '2022',
      status: 'Pending',
      type: 'Indian Patent Application'
    },
    {
      id: 'in-patent-4',
      title: 'CATALYST FOR THE PARTIAL OXIDATION OF SUBSTRATE TO VALUE ADDED PRODUCT UNDER AMBIENT CONDITIONS',
      applicationNumber: '202211057120',
      inventors: [
        'Vinod Chathakudath Prabhakaran',
        'Anuradha Vijay Jagtap',
        'Pawan Kumar Singh',
        'Sharad Gupta'
      ],
      filingDate: '2022',
      status: 'Pending',
      type: 'Indian Patent Application'
    },
    {
      id: 'pct-patent-1',
      title: 'SHAPED METAL OXIDES (PEROVSKITES), AND A PROCESS FOR PREPARATION THEREOF',
      applicationNumber: 'PCT/IN2024/050509',
      inventors: ['Vinod Chathakudath Prabhakaran', 'Pawan Kumar Singh'],
      filingDate: '2024',
      status: 'Pending',
      type: 'PCT Application'
    }
  ]
};